exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mb50[data-v-4130061d]{margin-bottom:50px}[data-v-4130061d] .el-table thead.is-group th{background-color:#f7fbff;border-color:#fff}[data-v-4130061d] .el-table{border:none}.box[data-v-4130061d]{position:relative}\n", ""]);

// exports
